import {
    OrganizationAction,
    USER_ORGANIZATION_ROLE_ACTIONS,
} from "@common/userOrganizationRoles";
import { useActiveOrganizationRole } from "./useActiveOrganizationRole";

/**
 * Returns whether the current user's organization role allows the given action.
 * Actions and their allowed roles are defined in USER_ORGANIZATION_ROLE_ACTIONS.
 */
export function useCanPerformOrganizationAction(
    action: OrganizationAction,
): boolean {
    const role = useActiveOrganizationRole();

    if (!role) {
        return false;
    }

    return USER_ORGANIZATION_ROLE_ACTIONS[role].includes(action);
}
